import { lazy } from 'react'
import HomeConfig from '@src/app/home/HomeConfig'

import WebLinkConfig from '@src/app/weblink/WeblinkConfig'
// ** Document title
const TemplateTitle = '%s - BQ WebLink'

// ** Default Route
const DefaultRoute = '/home'

// ** Merge Routes
const Routes = [
  HomeConfig,
  WebLinkConfig 
]

export { DefaultRoute, TemplateTitle, Routes }
